import { render } from "./ListViewTableButtons.vue?vue&type=template&id=974656a6"
import script from "./ListViewTableButtons.vue?vue&type=script&lang=js"
export * from "./ListViewTableButtons.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__